import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';  
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-fmtdespliegue',
  templateUrl: './fmtdespliegue.component.html',
  styleUrls: ['./fmtdespliegue.component.scss']
})
export class FmtdespliegueComponent implements OnInit {
  constructor(
    public authService: AuthService,public router: Router) { }
  ngOnInit() {    
    this.anio=-1;    
    this.ls_hk();
    this.get_org();
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  org;
  duenio_id_n1=0;
  duenio_id_nr="";

  //Revisar
  async get_org(){
    if (this.proyecto == "") return;
    let postData = {
      id_hk:this.proyecto,
    }
    var res;
    await this.authService.service("/api/getevl_hk",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res1 = JSON.parse(dat);    
        
        res = res1;
        
      });   
      var _arr= [];
      for(let i = 0; i < res.length;i++){
        
        if (res[i].lado == 5){
          var persona = "";
          if (res[i].persona == null){
            persona = await this.get_nombre1(res[i].id_ant);
          }else{
            persona = res[i].persona;
          }
          _arr.push({
            id:res[i].id,
            persona:persona 
          });
        }
      }      
      this.org=_arr;       
  }

  async get_nombre1(id){
    var nom; 
    let postData = {id_role:id }                         
    await this.authService.service("/api/get_persona_id_role",postData)
    .then(
        data => {               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
                                    
          nom =res[0].nombre+" "+res[0].apaterno+" "+res[0].amaterno;   
          //nom =res[0].puesto;                                      
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! reportto', '', 'error');
        });  
        return nom;    
    
  }

  get_org1(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    }       
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            console.log(this.org)
            var bnd=0;
            for(var i=0;i<this.org.length;i++){              
              if(this.org[i].director==1){
                if(bnd==0){               
                  console.log(this.org[i]);
                  this.duenio_id_n1= this.org[i].id_role;  
                  console.log(this.org[i].id_role);
                  bnd=1;
                }
              }              
            }  
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });                
    }
  
  fmt(){
    var api="/api/despliegue_usu";
    if(this.duenio_id_n1==this.responsable){     
      api="/api/despliegue_resp";
    }
    localStorage.setItem("api",api);
    localStorage.setItem("duenio",this.duenio_id_n1.toString());
    localStorage.setItem("responsable",this.responsable.toString())
    localStorage.setItem("proyecto",this.proyecto.toString())
    for(var i=0;i<this.org.length;i++){ 
      if(this.org[i].id_role==this.responsable){
        localStorage.setItem("responsable_tx",this.org[i].persona)
      }
    }
    for(var i=0;i<this.hk_list.length;i++){ 
      if(this.hk_list[i].id==this.proyecto){
        localStorage.setItem("proyecto_tx",this.hk_list[i].nombre)
      }
    }
    this.router.navigate([]).then(result => {  window.open('./#/despliegue', '_blank'); });     
  }
  hk_list=[];
  ls_hk(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    }
    this.authService.service("/api/get_hk",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.hk_list=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  
  }
  eval=[];
  meta_="";
  evaluacion=0;
  mes="";
  descripcion_:"";
  gda_eval(){
    let postData = {
      id_eval:this.id_eval,
      mes:this.mes_n,
      evaluacion:this.evaluacion>100?100:this.evaluacion,
      descripcion:this.descripcion_,
      id_responsable:this.responsable
    }
    console.log(postData);
    this.authService.service("/api/gda_despliegue_eval",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.despliegue();        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  id_eval=0;
  mes_n=0;
  v_eval(mes,itm){
    this.mes_n=mes;
    this.descripcion_=itm.descripcion;
    this.id_eval=itm.id_eval;
    console.log(itm);
    this.meta_=itm.meta;
    switch (mes) {
      case 1:this.mes="Enero";this.evaluacion=itm.ene;break;
      case 2:this.mes="Febrero";this.evaluacion=itm.feb;break;
      case 3:this.mes="Marzo";this.evaluacion=itm.mar;break;
      case 4:this.mes="Abril";this.evaluacion=itm.abr;break;
      case 5:this.mes="Mayo";this.evaluacion=itm.may;break;
      case 6:this.mes="Junio";this.evaluacion=itm.jun;break;
      case 7:this.mes="Julio";this.evaluacion=itm.jul;break;
      case 8:this.mes="Agosto";this.evaluacion=itm.ago;break;
      case 9:this.mes="Septiembre";this.evaluacion=itm.sep;break;
      case 10:this.mes="Octubre";this.evaluacion=itm.oct;break;
      case 11:this.mes="Noviembre";this.evaluacion=itm.nov;break;
      case 12:this.mes="Diciembre";this.evaluacion=itm.dic;break;      
    }
    this.meta_=itm.nombre     
  }
  anio=0;
  id_hk=0;
  despliegue_=[];
  proyecto="";
  total_proyecto=0;
  responsable=0;

  //Revisar
  despliegue(){
    if(Number(this.proyecto)==0)return;
    let postData = {
      id_hk:this.proyecto,
      usu:this.responsable,
      id_responsable:this.responsable
    }
    this.total_proyecto=0;
    var api="/api/despliegue_usu1";
    //console.log(this.duenio_id_n1);
    //console.log(this.responsable);
    /*
    if(this.duenio_id_n1==this.responsable){
      console.log("es responsalbe");
      api="/api/despliegue_resp";
    }*/
    this.authService.service(api,postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.despliegue_=res;
        var t =0;
        for(var i=0;i<this.despliegue_.length;i++){
          t=t+(
            this.despliegue_[i].ene+
            this.despliegue_[i].feb+
            this.despliegue_[i].mar+
            this.despliegue_[i].abr+
            this.despliegue_[i].may+
            this.despliegue_[i].jun+
            this.despliegue_[i].jul+
            this.despliegue_[i].ago+
            this.despliegue_[i].sep+
            this.despliegue_[i].oct+
            this.despliegue_[i].nov+
            this.despliegue_[i].dic)/12;          
        } 
        this.total_proyecto=t/(this.despliegue_.length+1)       
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }

  despliegue1(){
    if(Number(this.proyecto)==0)return;
    let postData = {
      id_hk:this.proyecto,
      usu:this.responsable,
      id_responsable:this.responsable
    }
    this.total_proyecto=0;
    var api="/api/despliegue_usu";
    //console.log(this.duenio_id_n1);
    //console.log(this.responsable);
    if(this.duenio_id_n1==this.responsable){
      console.log("es responsalbe");
      api="/api/despliegue_resp";
    }
    this.authService.service(api,postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.despliegue_=res;
        var t =0;
        for(var i=0;i<this.despliegue_.length;i++){
          t=t+(
            this.despliegue_[i].ene+
            this.despliegue_[i].feb+
            this.despliegue_[i].mar+
            this.despliegue_[i].abr+
            this.despliegue_[i].may+
            this.despliegue_[i].jun+
            this.despliegue_[i].jul+
            this.despliegue_[i].ago+
            this.despliegue_[i].sep+
            this.despliegue_[i].oct+
            this.despliegue_[i].nov+
            this.despliegue_[i].dic)/12;          
        } 
        this.total_proyecto=t/(this.despliegue_.length+1)       
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }
}
